import "antd/es/config-provider/style";
import _ConfigProvider from "antd/es/config-provider";

var _ConfigProvider$Confi;

import { ConfigConsumer } from "antd/es/config-provider";
var MergedConfigConsumer = (_ConfigProvider === null || _ConfigProvider === void 0 ? void 0 : (_ConfigProvider$Confi = _ConfigProvider.ConfigContext) === null || _ConfigProvider$Confi === void 0 ? void 0 : _ConfigProvider$Confi.Consumer) || ConfigConsumer;
export default MergedConfigConsumer;